import React from 'react';
import css from './Upload.module.css';
import axios from 'axios';

import FolderTree from '../components/FolderTree';

import {
  Container,
  Grid,
  Button,
  FormControl,
  TextField,
} from '@material-ui/core';

import { Autocomplete } from '@material-ui/lab';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';


class Upload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      date: null,
      people: '',
      clinicCode: [],
      category: [],
      description: '',
      folderPrefix: '',
      folderId: '0',
      folderReset: () => {},
    };
  }

  componentDidMount() {

  }

  handleStateChange = (key, value) => {
    this.setState({[key]: value});
  }

  resetForm = () => {
    this.setState({
      file: null,
      date: null,
      people: '',
      clinicCode: [],
      category: [],
      description: '',
      folderPrefix: '',
      folderId: '0',
    });
    this.state.folderReset();
  }

  handleFormSubmit = async (e) => {
    e.preventDefault();
    if(!this.state.file)
      return;

    this.props.alert(
      'HIPAA Attestation',
      'By uploading these files, you confirm that the contents do not contain any HIPAA data, or that the HIPAA data contents have been properly released.',
      false,
      this.handleFormSubmitConfirm
    );
  }

  handleFormSubmitConfirm = async (result) => {
    if(!result)
      return this.props.alert('Upload Canceled');
    
    let files = this.state.file.files;
    let folderPrefix = this.state.folderPrefix;
    let metadata = {
      file_name: null,
      file_type: null,
      people: this.state.people,
      clinic_code: this.state.clinicCode.map((code) => code.value).join(', '),
      categories: this.state.category.map((code) => code.value).join(', '),
      description: this.state.description,
      user_date: this.state.date && this.state.date.toISOString().substr(0, 10),
      uploaded_by: this.props.user,
    };

    let notiSuffix = `${metadata.folderId}-${(new Date()).toISOString()}`;
    let notis = this.makeNotifications(files, notiSuffix);
    for(let i = 0; i < notis.length; ++i)
      await this.props.notiActions.add(notis[i])

    this.resetForm();
    this.props.alert(`Uploading ${files.length} File(s)`, 'Please check the notification area for progress');
    try {
      for(let i = 0; i < files.length; ++i) {
        let file = files[i];
        let fileName = file.name;
        let fileNameParts = fileName.split('.');
        let fileType = fileNameParts.length > 1 ? fileNameParts.pop().toLowerCase() : 'none';
        metadata.file_name = `${folderPrefix}${fileName}`;
        metadata.file_type = fileType;

        if(!this.props.allowedTypes.includes(fileType)) {
          await this.props.notiActions.update({ id: `${fileName}-${notiSuffix}`, title: `Error Uploading: file type "${fileType}" not allowed`, status: 'done' });
          continue;
        }

        await this.props.notiActions.update({ id: `${fileName}-${notiSuffix}`, title: 'Uploading', status: 'in progress' });
        // await new Promise((resolve, reject) => setTimeout(() => resolve(), 6000));
        await this.createMetadata(metadata);
        let fileSasUrl = await this.getFileUrl(metadata.file_name, 'write');
        await this.uploadFileSAS(file, fileSasUrl, notiSuffix);
        // await new Promise((resolve, reject) => setTimeout(() => resolve(), 6000));
        await this.props.notiActions.update({ id: `${fileName}-${notiSuffix}`, title: 'Upload Complete', status: 'done' });
      }
    } catch(err) {
      this.resetForm();
      console.log(err);
    }
  }

  makeNotifications = (files, notiSuffix) => {
    let result = [];
    for(let i = 0; i < files.length; ++i) {
      let temp = {
        id: `${files[i].name}-${notiSuffix}`,
        title: 'Upload pending',
        message: `File ${files[i].name}`,
        status: 'waiting',
        progress: 0,
      };
      result.push(temp);
    }
    return result;
  }

  createMetadata = (params) => {
    return new Promise(async (resolve, reject) => {
      try {
        let endpoint = `/api/upsert`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  getFileUrl = (path, action='write', preview=false) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path, action: action, preview: preview });
        let endpoint = `/api/sasurl?${params}`;
        let response = await fetch(endpoint);
        let result = await response.json();
        return resolve(result.url);
      }
      catch(err) {
        return reject();
      }
    });
  }

  uploadFileSAS = async (file, sasUrl, notiSuffix) => {
    return axios.put(sasUrl, file, {
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type
      },
      onUploadProgress: async (progressEvent) => {
        const uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
        await this.props.notiActions.update({
          id: `${file.name}-${notiSuffix}`,
          progress: uploadProgress
        });
      }
    });
  }

  getFileList = () => {
    let output = [];
    if(this.state.file)
      for(let i=0; i < this.state.file.files.length; ++i)
        output.push(<div key={i}>{this.state.file.files[i].name}</div>);
    return output;
  }

  folderOnSelect = (folderPrefix, folderId) => {
    this.setState({ folderPrefix: folderPrefix, folderId: folderId });
  }

  folderOnInit = ({ reset, hash }) => {
    this.setState({ folderReset: reset, folderHash: hash });
  }

  render() {
    return (
      <form onSubmit={this.handleFormSubmit}>
        <Container>
          <br/>
          <Grid container spacing={2}>
            <Grid container item xs={7} spacing={2}>
              <Grid item xs={12}>
                <Button variant="contained" component="label">Select Files
                  <input name="file" type="file" onChange={(event) => this.handleStateChange('file', event.target)} multiple hidden />
                </Button>
              </Grid>

              <FormControl className="w-100 m-1">
                <FolderTree onInit={this.folderOnInit} onSelect={this.folderOnSelect} />
              </FormControl>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  name="date"
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date"
                  className="m-1 w-100"
                  label="Date"
                  value={this.state.date}
                  onChange={(date) => this.handleStateChange('date', date)}
                  autoOk={true}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
              <FormControl className="w-100 m-1">
                <TextField 
                  labelId="people-input-label" 
                  id="standard-basic" 
                  label="People" 
                  value={this.state.people}
                  onChange={(event) => this.handleStateChange('people', event.target.value)}
                />
              </FormControl>

              <FormControl className="w-100 m-1">
                <Autocomplete
                  multiple
                  id="clinic-code-select"
                  options={this.props.clinicCodes}
                  getOptionLabel={(option) => `${option.value} - ${option.display}`}
                  groupBy={(option) => option.type}
                  value={this.state.clinicCode}
                  onChange={(event, newValue) => this.handleStateChange('clinicCode', newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Clinic Code"
                      placeholder=""
                    />
                  )}
                />
              </FormControl>
              
              <FormControl className="w-100 m-1">
                <Autocomplete
                  multiple
                  id="category-select"
                  options={this.props.categories}
                  getOptionLabel={(option) => `${option.value} - ${option.display}`}
                  value={this.state.category}
                  onChange={(event, newValue) => this.handleStateChange('category', newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Categories"
                      placeholder=""
                    />
                  )}
                />
              </FormControl>

              <FormControl className="w-100 m-1 mb-4">
                <TextField 
                  labelId="description-input-label" 
                  id="description" 
                  label="Description"
                  multiline={true}
                  rows={5}
                  value={this.state.description}
                  onChange={(event) => this.handleStateChange('description', event.target.value)}
                />
              </FormControl>
              
              <Button className="mr-2" type="submit" variant="contained">Upload</Button>
              <Button onClick={() => this.resetForm()} variant="contained">Clear</Button>
            </Grid>

            <Grid item xs={5}>
              <div className={css.bold}>Selected Files:</div>
              <div>
                {this.getFileList()}
              </div>
            </Grid>
          </Grid>
        </Container>
      </form>
    )
  }
}

Upload.defaultProps = {
  clinicCodes: [
    // CLINIC
    {value: 'ASC', display: 'Ambulatory Surgery Center', type: 'Clinics'},
    {value: 'PAIN', display: 'Back and Neck Pain Center', type: 'Clinics'},
    {value: 'CMC', display: 'Comprehensive Memory Center', type: 'Clinics'},
    {value: 'DERM', display: 'Dermatology', type: 'Clinics'},
    {value: 'ENDO', display: 'Endocrinology', type: 'Clinics'},
    {value: 'INF', display: 'Infectious Disease', type: 'Clinics'},
    {value: 'LCI', display: 'Livestrong Cancer Institutes', type: 'Clinics'},
    {value: 'EYE', display: 'Mitchel and Shannon Wong Eye Institute', type: 'Clinics'},
    {value: 'MS', display: 'Multiple Sclerosis and Neuroimmunology Center', type: 'Clinics'},
    {value: 'MULV', display: 'Mulva Clinic for the Neurosciences', type: 'Clinics'},
    {value: 'MSK', display: 'Musculoskeletal Institute', type: 'Clinics'},
    {value: 'PRIM', display: 'Primary Care', type: 'Clinics'},
    {value: 'RHEUM', display: 'Rheumatology', type: 'Clinics'},
    {value: 'SURGONC', display: 'Surgical Oncology', type: 'Clinics'},
    {value: 'WI', display: 'Walk In', type: 'Clinics'},
    // ADULT PARTNER PROGRAMS
    {value: 'DM', display: 'Digestive Health', type: 'Adult Partner Programs'},
    {value: 'TC', display: 'Transplant Center', type: 'Adult Partner Programs'},
    {value: 'WH', display:"Women’s Health", type: 'Adult Partner Programs'},
    // PEDIATRIC PARTNER PROGRAMS
    {value: 'CFCC', display: 'Comprehensive Fetal Care Center', type: 'Pediatric Partner Programs'},
    {value: 'TCPCHD', display: 'Texas Center for Pediatric and Congenital Heart Disease', type: 'Pediatric Partner Programs'},
    {value: 'PEDIPRIM', display: 'Primary Pediatrics at Mueller', type: 'Pediatric Partner Programs'},
    {value: 'PEDINEURO', display: "UT Health Austin Pediatric Neurosciences at Dell Children's", type: 'Pediatric Partner Programs'},
    {value: 'PEDIPSYCH', display: "UT Health Austin Pediatric Psychiatry at Dell Children’s", type: 'Pediatric Partner Programs'},
    // ORGANIZATION
    {value: 'UTHA', display: 'UT Health Austin', type: 'Organizations'},
    {value: 'DCMC', display: "Dell Children’s Medical Center", type: 'Organizations'},
    {value: 'DMS', display: 'Dell Medical School', type: 'Organizations'},
    {value: 'ASCSTN', display: 'Ascension Seton', type: 'Organizations'},
  ],
  categories: [
    {value: 'patientStory', display: 'Patient Story'},
    {value: 'askFriend', display: 'Asking for a Friend'},
    {value: 'providerBio', display: 'Provider Bio Video'},
    {value: 'healthCuriosity', display: 'Healthy Curiosity'},
    {value: 'interview', display: 'Interview'},
    {value: 'surgeryProcedure', display: 'Surgery/Procedure'},
    {value: 'event', display: 'Event'},
  ],
  videoTypes: ['mxf', 'mp4', 'mpeg4', 'mov', 'm4v'],
  allowedTypes: [ 'mpeg4', 'jpg', 'mp4', 'mov', 'wav', 'mif', 'bdm', 'ctg',
    'mxf', 'ind', 'pdf', 'cr3', 'cr2', 'png', 'mp3', 'arw', 'bin', 'xml',
    'pkf', 'xmp', 'jpeg', 'gif', 'bmp', 'm4v', 'svg' ],
};


export default Upload;
